// TODO: TS: check ts

import React from "react";

import { Button, ButtonProps } from "./ButtonNew";
import { Icon, IconProps } from "./Icon";

export type IconButtonProps = {
  buttonProps: ButtonProps;
  children?: React.ReactNode;
  iconProps: IconProps;
};

const disabledIconColor = "var(--color-foreground-disabled)";
const activeIconColor = "var(--color-element-primary-initial)";

export const IconButton = ({ buttonProps, iconProps }: IconButtonProps) => {
  let { color, fill, stroke } = iconProps;
  const iconColorIfPrimary = buttonProps.variant === "primary" ? "var(--color-element-primary-on-primary)" : undefined;
  const { disabled, isActive } = buttonProps;

  if (fill) fill = disabled ? disabledIconColor : isActive ? activeIconColor : fill;
  if (stroke) stroke = disabled ? disabledIconColor : isActive ? activeIconColor : stroke;
  const iconColor = disabled ? disabledIconColor : isActive ? activeIconColor : color || iconColorIfPrimary;

  return (
    <Button {...buttonProps} disabled={disabled} isActive={isActive}>
      <Icon {...iconProps} color={iconColor} fill={fill} stroke={stroke} />
    </Button>
  );
};
